import React, {useContext, useEffect, useState} from 'react'
import {Box} from '@mui/material'
import {useStyles} from './styles'
import {GalleryInfoContext} from "../../../components/GalleryInfoContext";
/* eslint-disable  no-unused-vars, no-debugger */

const ImgGallery = () => {
    const [imageObjects, setImageObjects] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0)
    const classes = useStyles()
    const {galleryInfo} = useContext(GalleryInfoContext);

    // ✅ compute unique URLs directly from contactInfo
    const uniqueImageUrls = React.useMemo(
        () => Array.from(new Set(galleryInfo?.tintedImages || [])),
        [galleryInfo]
    );

    useEffect(() => {
        if (!uniqueImageUrls.length) return;

        // ✅ build objects directly from URLs
        const newImageObjects = uniqueImageUrls.map((url) => ({
            id: url,
            src: url,
        }));

        setImageObjects(newImageObjects);
    }, [uniqueImageUrls]); // ✅ correct dependency

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Box
                    sx={{
                        width: '50%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                    }}
                >
                    {imageObjects[currentIndex] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex].src}
                                alt={`Image ${imageObjects[currentIndex].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 1] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 1].src}
                                alt={`Image ${imageObjects[currentIndex + 1].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 2] && (
                        <Box className={classes.currentIndexMax}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 2].src}
                                alt={`Image ${imageObjects[currentIndex + 2].id}`}
                            />
                        </Box>
                    )}
                </Box>
                <Box
                    sx={{
                        width: '50%',
                        height: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                    }}
                >
                    {imageObjects[currentIndex + 3] && (
                        <Box className={classes.currentIndexMax}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 3].src}
                                alt={`Image ${imageObjects[currentIndex + 3].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 4] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 4].src}
                                alt={`Image ${imageObjects[currentIndex + 4].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 5] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 5].src}
                                alt={`Image ${imageObjects[currentIndex + 5].id}`}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Box
                    sx={{
                        width: '50%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                    }}
                >
                    {imageObjects[currentIndex + 6] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 6].src}
                                alt={`Image ${imageObjects[currentIndex + 6].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 7] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 7].src}
                                alt={`Image ${imageObjects[currentIndex + 7].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 8] && (
                        <Box className={classes.currentIndexMax}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 8].src}
                                alt={`Image ${imageObjects[currentIndex + 8].id}`}
                            />
                        </Box>
                    )}
                </Box>
                <Box
                    sx={{
                        width: '50%',
                        height: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                    }}
                >
                    {imageObjects[currentIndex + 9] && (
                        <Box className={classes.currentIndexMax}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 9].src}
                                alt={`Image ${imageObjects[currentIndex + 9].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 10] && (
                        <Box className={classes.currentIndexMin}>
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 10].src}
                                alt={`Image ${imageObjects[currentIndex + 10].id}`}
                            />
                        </Box>
                    )}
                    {imageObjects[currentIndex + 11] && (
                        <Box
                            sx={{
                                width: '100%',
                                height: '370px',
                            }}
                        >
                            <img
                                className={classes.percent_100}
                                src={imageObjects[currentIndex + 11].src}
                                alt={`Image ${imageObjects[currentIndex + 11].id}`}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default ImgGallery
